import React from "react";

export default function GanttMilestone(props) {

  var {
    date,
    timelineStart,
    weekWidth,
    rowHeight,
    colour,
    title
  } = props;

  function daysBetween(a, b) {
    var ms = b.getTime() - a.getTime();
    return Math.round(ms / (1000 * 60 * 60 * 24));
  }

  var days = daysBetween(timelineStart, date);
  var left = (days / 7) * weekWidth;

  return (
    <div
      title={title}
      style={{
        position: "absolute",
        left: left - 6,
        top: (rowHeight / 2) - 11,
        width: 12,
        height: 12,
        background: colour,
        transform: "rotate(45deg)",
        borderRadius: "2px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
        cursor: "pointer"
      }}
    />
  );
}
